import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./router/routes";
import "./index.css";
import "./font.css";
import './utils/rem'

import AudioProvider from '../src/components/bgm/index';
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AudioProvider>
        <Suspense>
          <Routes />
        </Suspense>
      </AudioProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
